
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import item from './resumen-item.vue';
    import { Wait } from '@/__env/ext';
    import { ControladorSeccion } from '@/views/a-pedidos-ml/pc/lista/controlador';
    import { Transporte } from '@/__env/lib/Expedicion/Transportes';
import { ResumenPublicacionesMercadoLibre } from '@/__env/lib/MercadoLibre/Publicaciones/Resumen';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            item
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public Valores: any = [{}, {}, {}, {},];
        public Cargando: boolean = true;
        public EstadoSeleccionado: string = '-';
        public Estadistica: ResumenPublicacionesMercadoLibre = new ResumenPublicacionesMercadoLibre();


        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {
            await this.Iniciar();
            this.Eventos.push( this.Controlador.Buscador.onActualizar.subscribe( () => { this.Iniciar(); } ) );
            this.Eventos.push( this.Controlador.onRecargarEstadistica.subscribe( () => { this.Iniciar(true); } ) );

        }

        async Iniciar( forzar: boolean = false)
        {
            if ( !forzar && this.EstadoSeleccionado == this.Controlador.Buscador.Filtros.Cuentas[this.Controlador.Buscador.Filtros.Valores.Cuenta].Id )
            {
                return;
            }

            this.Cargando = true;
            await Wait( 1500 );

            this.EstadoSeleccionado = this.Controlador.Buscador.Filtros.Cuentas[this.Controlador.Buscador.Filtros.Valores.Cuenta].Id;
            this.Estadistica = await ResumenPublicacionesMercadoLibre.create( this.EstadoSeleccionado );



            this.Valores.clear();
            let activas = {
                Titulo: 'Activas',
                Valor: this.Estadistica.Datos.activas.total,
                Problema: this.Estadistica.Datos.activas.detalles.con_error_codigo > 0,
                Accion: () => { this.Controlador.Buscador.Filtros.Valores.Estado = this.Controlador.Buscador.Filtros.Estados.findIndex( x => x.Valor.findIndex( a => a.Id == 'active' ) > -1 ); this.Controlador.Buscador.Buscar( 1 ); },
                Opciones: [
                    {
                        Titulo: 'Financiadas',
                        Valor: this.Estadistica.Datos.activas.detalles.financiadas,
                        Accion: () =>
                        {
                            this.Controlador.Buscador.Filtros.Valores.Estado = this.Controlador.Buscador.Filtros.Estados.findIndex( x => x.Valor.findIndex( a => a.Id == 'active' ) > -1 );
                            this.Controlador.Buscador.Filtros.Valores.Tipo = this.Controlador.Buscador.Filtros.Tipos.findIndex( x => x.Valor.findIndex( a => a.Id == 'gold_pro' ) > -1 );
                            this.Controlador.Buscador.Buscar( 1 );
                        },
                    },

                    {
                        Titulo: 'De contado',
                        Valor: this.Estadistica.Datos.activas.detalles.contado,
                        Accion: () =>
                        {
                            this.Controlador.Buscador.Filtros.Valores.Estado = this.Controlador.Buscador.Filtros.Estados.findIndex( x => x.Valor.findIndex( a => a.Id == 'active' ) > -1 );
                            this.Controlador.Buscador.Filtros.Valores.Tipo = this.Controlador.Buscador.Filtros.Tipos.findIndex( x => x.Valor.findIndex( a => a.Id == 'gold_special' ) > -1 );
                            this.Controlador.Buscador.Buscar( 1 );
                        },
                    },

                    {
                        Titulo: 'En falta',
                        Valor: this.Estadistica.Datos.activas.detalles.en_falta,
                        Accion: () =>
                        {
                            this.Controlador.Buscador.Filtros.Valores.Tipo = 0;
                            this.Controlador.Buscador.Filtros.Valores.Estado = this.Controlador.Buscador.Filtros.Estados.findIndex( x => x.Valor.findIndex( a => a.Id == 'active' ) > -1 );
                            this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'en_falta' );
                            this.Controlador.Buscador.Buscar( 1 );
                        },
                    },

                    {
                        Titulo: 'Problemas con codigos',
                        Valor: this.Estadistica.Datos.activas.detalles.con_error_codigo,
                        Problema: this.Estadistica.Datos.activas.detalles.con_error_codigo > 0,
                        Accion: () =>
                        {
                            this.Controlador.Buscador.Filtros.Valores.Estado = this.Controlador.Buscador.Filtros.Estados.findIndex( x => x.Valor.findIndex( a => a.Id == 'active' ) > -1 );
                            this.Controlador.Buscador.Filtros.Valores.Tipo = 0;
                            this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'error_en_codigo' );
                            this.Controlador.Buscador.Buscar( 1 );
                        },
                    },

                ]


            };


            this.Valores.push( activas );

            let pausadas = {
                Titulo: 'Pausadas',
                Valor: this.Estadistica.Datos.pausadas.total,
                Accion: () => { this.Controlador.Buscador.Filtros.Valores.Estado = this.Controlador.Buscador.Filtros.Estados.findIndex( x => x.Valor.findIndex( a => a.Id == 'paused' ) > -1 ); this.Controlador.Buscador.Buscar( 1 ); },
                Opciones: [
                    {
                        Titulo: 'Financiadas',
                        Valor: this.Estadistica.Datos.pausadas.detalles.financiadas,
                        Accion: () =>
                        {
                            this.Controlador.Buscador.Filtros.Valores.Estado = this.Controlador.Buscador.Filtros.Estados.findIndex( x => x.Valor.findIndex( a => a.Id == 'paused' ) > -1);
                            this.Controlador.Buscador.Filtros.Valores.Tipo = this.Controlador.Buscador.Filtros.Tipos.findIndex( x => x.Valor.findIndex( a => a.Id == 'gold_pro' ) > -1);
                            this.Controlador.Buscador.Buscar( 1 );
                        },
                    },

                    {
                        Titulo: 'De contado',
                        Valor: this.Estadistica.Datos.pausadas.detalles.contado,
                        Accion: () =>
                        {
                            this.Controlador.Buscador.Filtros.Valores.Estado = this.Controlador.Buscador.Filtros.Estados.findIndex( x => x.Valor.findIndex( a => a.Id == 'paused' ) > -1 );
                            this.Controlador.Buscador.Filtros.Valores.Tipo = this.Controlador.Buscador.Filtros.Tipos.findIndex( x => x.Valor.findIndex( a => a.Id == 'gold_special' ) > -1 );
                            this.Controlador.Buscador.Buscar( 1 );
                        },
                    },

                    {
                        Titulo: 'Pausadas por faltante',
                        Valor: this.Estadistica.Datos.pausadas.detalles.pausado_por_faltante,
                        Accion: () =>
                        {
                            this.Controlador.Buscador.Filtros.Valores.Tipo = 0;
                            this.Controlador.Buscador.Filtros.Valores.Estado = this.Controlador.Buscador.Filtros.Estados.findIndex( x => x.Valor.findIndex( a => a.Id == 'paused' ) > -1 );
                            this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'pausado_por_faltante' );
                            this.Controlador.Buscador.Buscar( 1 );
                        },
                    },

                    {
                        Titulo: 'Disponible para reactivar',
                        Valor: this.Estadistica.Datos.pausadas.detalles.disponible_para_reactivar,
                        Problema: this.Estadistica.Datos.pausadas.detalles.disponible_para_reactivar > 0,
                        Accion: () =>
                        {
                            this.Controlador.Buscador.Filtros.Valores.Tipo = 0;
                            this.Controlador.Buscador.Filtros.Valores.Estado = this.Controlador.Buscador.Filtros.Estados.findIndex( x => x.Valor.findIndex( a => a.Id == 'paused' ) > -1 );
                            this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'disponible_para_reactivar' );
                            this.Controlador.Buscador.Buscar( 1 );
                        },
                    },

                    {
                        Titulo: 'Problemas con codigos',
                        Valor: this.Estadistica.Datos.pausadas.detalles.con_error_codigo,
                        Problema: this.Estadistica.Datos.pausadas.detalles.con_error_codigo > 0,
                        Accion: () =>
                        {
                            this.Controlador.Buscador.Filtros.Valores.Tipo = 0;
                            this.Controlador.Buscador.Filtros.Valores.Estado = this.Controlador.Buscador.Filtros.Estados.findIndex( x => x.Valor.findIndex( a => a.Id == 'paused' ) > -1 );
                            this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'error_en_codigo' );
                            this.Controlador.Buscador.Buscar( 1 );
                        },
                    },

                ]
            };

            this.Valores.push( pausadas );


            let cerradas = {
                Titulo: 'Cerradas',
                Valor: this.Estadistica.Datos.cerradas.total,
                Accion: () => { this.Controlador.Buscador.Filtros.Valores.Estado = this.Controlador.Buscador.Filtros.Estados.findIndex( x => x.Valor.findIndex( a => a.Id == 'closed' ) > -1 ); this.Controlador.Buscador.Buscar( 1 ); },
                Opciones: [
                    {

                    },

                ]
            };

            this.Valores.push( cerradas );

            this.Cargando = false;
        }


    }
